import { Injectable } from '@angular/core';

@Injectable()
export class DateValidatorService {

    public isDate(possibleDate:any):boolean{
        return possibleDate instanceof Date && !isNaN(possibleDate.valueOf());
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/validation/date-validator.service.ts